import styles from "./StatCard.module.css";

export function StatGrid({ children }) {
  return <div className={styles.grid}>{children}</div>;
}

// `suffix` sits after the value on its line (e.g. "$250 / activation"); `tone` colours the
// value (brand | warning); `highlight` fills the card in brand green; `action` sits at the
// right end of the value row (e.g. a "View →" link)
export default function StatCard({ label, value, note, suffix, tone, action, highlight = false }) {
  const toneClass = tone ? styles[`value${tone[0].toUpperCase()}${tone.slice(1)}`] : "";
  const valueLine = (
    <p className={`${styles.value} ${toneClass}`}>
      {value}
      {suffix ? <span className={styles.suffix}> {suffix}</span> : null}
    </p>
  );

  return (
    <article className={`${styles.card} ${highlight ? styles.highlight : ""}`}>
      <p className={`${styles.label} label-font`}>{label}</p>
      {action ? (
        <div className="d-flex align-items-end justify-content-between gap-2">
          {valueLine}
          {action}
        </div>
      ) : (
        valueLine
      )}
      {note ? <p className={styles.note}>{note}</p> : null}
    </article>
  );
}
